// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2ijea","colMaxWidth":"Table_colMaxWidth__ajN5b"};